import {Alert} from 'platform/components';

import i18n from '@dms/i18n';
import {customerRoutes} from '@dms/routes';

import {composePath, TestIdProps} from 'shared/web';

interface CustomerDetailAlertProps extends TestIdProps {
  customerId: string;
  title: string;
}

export function CustomerDetailAlert(props: CustomerDetailAlertProps) {
  return (
    <Alert
      type="inline"
      variant="error"
      title={props.title}
      hyperlinks={[
        {
          title: i18n.t('page.customer.viewCustomer'),
          rightIcon: 'action/launch',
          target: '_blank',
          href: composePath(customerRoutes.detail, {params: {id: props.customerId}}),
        },
      ]}
      data-testid={props['data-testid']}
    />
  );
}
